import { usePetitionDetailsPageFcm } from 'src/app/pages/petitionDetails/pageContext';

/**
 * @deprecated use usePetitionDetailsPageFcm() instead
 */
export const useFcm = usePetitionDetailsPageFcm;
